import { useState, useEffect } from 'react';
import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import isEqual from 'lodash-es/isEqual';
import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';

type LocationData = { id: string; name?: string; timeZone?: string };

export const useGetFilteredLocations = () => {
  const [filteredLocations, setFilteredLocations] = useState<LocationData[]>([]);
  const { getScopeName, locationData } = useAppScopeStore();
  const { getCustomizationFlagLocationMap } = useScopedAppFlagStore();

  const allowedLocations = getCustomizationFlagLocationMap(Feature.TASK_CENTER);

  useEffect(() => {
    const updatedLocations: LocationData[] = [];
    for (const locId in allowedLocations) {
      if (allowedLocations[locId]?.state === State.ACTIVE) {
        updatedLocations.push({ id: locId, name: getScopeName(locId), timeZone: locationData[locId]?.timezone });
      }
    }

    if (!isEqual(filteredLocations, updatedLocations)) {
      setFilteredLocations(updatedLocations);
    }
  }, [allowedLocations]);

  // return the id array and return the id with name array
  return filteredLocations;
};
